// Angular Schema Generated by Hub.AngularSchemaGenerator project.
// Re-run the project every time the backend schema changes
// Don't manually change this file.  This file is auto-generated, and any changes will be overwritten the next time the AngulaSchemaGenerator is run.

export class Goal2030DetailsModel {
	public theme?: string;
	public subTheme?: string;
	public sortOrder: number;
	public subThemeJson: string;
	public subThemes: Goal2030SubThemeModel[];
}

export class Goal2030SubThemeModel {
	public subTheme?: string;
	public sortOrder: number;
	public metricId: number;
	public metric?: string;
	public unitDisplay?: string;
	public shortUnitDisplay?: string;
	public regionalDetailsUnitId: number;
	public regionalDetailsUnitDisplay?: string;
	public regionalDetailsShortUnitDisplay?: string;
	public progressValue: number;
	public metricTargetValue: number;
	public metricTargetValueDisplay?: string;
	public floatingPointPrecision: number;
	public regionJson: string;
	public regions: Goal2030DetailsByRegionModel[];
	public top5StrategiesJson: string;
	public top5Strategies: Goal2030DetailsTop5StrategiesByProgress[];
}

export class Goal2030DetailsTop5StrategiesByProgress {
	public strategyProjectId: number;
	public strategyName?: string;
}

export class Goal2030DetailsByRegionModel {
	public regionId: number;
	public region?: string;
	public progressValue: number;
	public projectsDefinedTargetValue: number;
	public regionsProgressValue: number;
	public regionsTargetValue: number;
}

export class Goal2030Model {
	public goal2030Id: number;
	public name: string;
	public target: string;
	public achievementPlan: string;
	public sortOrder: number;
	public unitDisplay: string;
	public theme: string;
	public themeSubArea?: string;
	public subThemeInfo: string;
	public subThemeValues: SubThemeInfoModel[];
}

export class SubThemeInfoModel {
	public unitDisplay?: string;
	public themeSubArea?: string;
	public organizationalTargetValue: number;
	public sortOrder: number;
	public organizationalTargetValueDisplay?: string;
	public totalProgressValue: number;
	public tncPrincipalPercent: number;
	public tncDirectPercent: number;
	public tncIndirectPercent: number;
	public projectsDefinedTargetValue: number;
}

export class NormalizedGoal2030DetailsModel {
	public theme: string;
	public sortOrder: number;
	public goal: Goal2030Model;
	public subThemes: NormalizedGoal2030DetailSubThemesModel[];
}

export class NormalizedGoal2030DetailSubThemesModel {
	public subTheme: string;
	public sortOrder: number;
	public metrics: NormalizedGoal2030DetailSubThemeMetricsModel[];
}

export class NormalizedGoal2030DetailSubThemeMetricsModel {
	public metricId: number;
	public metric: string;
	public unit: string;
	public shortUnit: string;
	public progressValue: number;
	public targetValue: number;
	public targetValueDisplay: string;
	public regionalDetailsUnitId: number;
	public regionalDetailsUnitDisplay: string;
	public regionalDetailsShortUnitDisplay: string;
	public floatingPointPrecision: number;
	public regions: NormalizedGoal2030DetailSubThemeMetricRegionsModel[];
	public recentStrategies: NormalizedGoal2030DetailSubThemeMetricStrategiesModel[];
}

export class NormalizedGoal2030DetailSubThemeMetricRegionsModel {
	public regionId: number;
	public region: string;
	public progressValue: number;
	public projectDefinedTargetValue: number;
	public regionsProgressValue: number;
	public regionsTargetValue: number;
}

export class NormalizedGoal2030DetailSubThemeMetricStrategiesModel {
	public strategyProjectId: number;
	public strategy: string;
}

export class HelpTextModel {
	public helpTextId?: number;
	public context: string;
	public label: string;
	public contentHtmlShort?: string;
	public link?: string;
}

export class ProjectDonorKeywordModel {
	public projectDonorKeywordId?: number;
	public projectId: number;
	public keyword: string;
}

export class AlgoliaInfoModel {
	public id: string;
	public key: string;
	public readOnlyKey: string;
	public insightIndexKey: string;
	public portfolioSearchIndexName: string;
	public globalSearchIndexName: string;
	public recordCollectionIndexName: string;
	public projectNameIndexName: string;
	public fundraisingMenuIndexName: string;
	public userIndexName: string;
	public insightIndexName: string;
	public submitToAlgolia: boolean;
}

export class AttributionLevelModel {
	public attributionLevelId: number;
	public name: string;
}

export class AuditLogModel {
	public auditLogId: number;
	public projectId?: number;
	public actionDate: Date;
	public action: string;
	public userId?: number;
	public user?: UserModel;
}

export class ProjectAffectedByCurrentUserModel {
	public businessUnitIds: number[];
	public businessRolesIds: number[];
	public currentSelectedUserId: number;
}

export class ProjectsAffectedRequestModel {
	public businessUnitIds: number[];
	public roleIds: number[];
}

export class BusinessUnitModel {
	public businessUnitId: number;
	public name: string;
	public isActive: boolean;
	public regionId: number;
	public region: RegionModel;
	public divisionId: number;
	public division: DivisionModel;
}

export class DivisionModel {
	public divisionId: number;
	public name: string;
	public isActive: boolean;
}

export class ProjectBusinessUnitModel {
	public projectBusinessUnitId?: number;
	public projectId?: number;
	public isLeadBusinessUnit: boolean;
	public businessUnitId: number;
	public businessUnit?: BusinessUnitModel;
}

export class RegionModel {
	public regionId: number;
	public name: string;
	public isActive: boolean;
}

export class ChangeLogModel {
	public action?: string;
	public actionDate: Date;
	public userId?: number;
	public userFullName?: string;
	public projectId?: number;
	public component: string;
}

export class ChangeLogSearchModel {
	public projectId: number;
	public days?: number;
	public users?: UserInfoModel[];
	public components?: string[];
	public page?: number;
	public sort?: SortModel;
}

export class ChangeLogSearchResultModel {
	public results: ChangeLogModel[];
	public page: number;
	public filteredItemsCount: number;
	public filteredPagesCount: number;
}

export class SortModel {
	public active: string;
	public direction: string;
}

export class FinancialContactTypeAheadModel {
	public editorPermission: string;
	public businessUnitIds?: number[];
}

export class FinanceMetricModel {
	public financeMetricId: number;
	public name: string;
	public code: string;
}

export class FinanceProjectSearchModel {
	public days?: number;
	public businessUnitIds: number[];
	public workdayName: string;
	public page?: number;
	public sort?: SortModel;
}

export class FinanceProjectSearchResultModel {
	public results: LinkedFinanceProjectModel[];
	public page: number;
	public filteredItemsCount: number;
	public filteredPagesCount: number;
}

export class ProjectFinancialModel {
	public projectFinancialId?: number;
	public projectId: number;
	public year: number;
	public value: number;
	public financeMetricId: number;
	public financeMetric?: FinanceMetricModel;
	public modifiedOn?: Date;
	public modifiedBy?: UserModel;
}

export class AvailableParentIntermediateResultsModel {
	public strategyId: number;
	public strategyName: string;
	public intermediateResults: ProjectIntermediateResultModel[];
}

export class IntermediateResultProgressModel {
	public intermediateResultProgressId?: number;
	public progressDate: Date;
	public progressValue: number;
	public attributionLevelId?: number;
	public attributionDescription?: string;
	public projectIntermediateResultId?: number;
	public isStart?: boolean;
	public attributionLevel?: AttributionLevelModel;
	public uniqueId?: string;
}

export class ChildIntermediateResultProgressModel extends IntermediateResultProgressModel {
	public childProjectId?: number;
	public childProjectName?: string;
}

export class IntermediateResultTargetModel {
	public intermediateResultTargetId?: number;
	public projectIntermediateResultId: number;
	public targetDate: Date;
	public targetValue: number;
	public uniqueId?: string;
}

export class ChildIntermediateResultTargetModel extends IntermediateResultTargetModel {
	public childProjectId?: number;
	public childProjectName?: string;
}

export class ProjectIntermediateResultModel {
	public projectIntermediateResultId?: number;
	public projectId: number;
	public statement?: string;
	public indicatorName?: string;
	public unit?: string;
	public isKeyResult?: boolean;
	public isVisibleOnDashboard?: boolean;
	public hasLeveragedIntermediateResult?: boolean;
	public isArchived?: boolean;
	public parentIntermediateResultId?: number;
	public parentIntermediateResultProjectName?: string;
	public sortOrder?: number;
	public scaleMeasureId?: number;
	public progress?: IntermediateResultProgressModel[];
	public targets?: IntermediateResultTargetModel[];
	public parentIntermediateResult?: ProjectIntermediateResultModel;
	public scaleMeasureDefinitions?: ScaleMeasureDefinitionModel[];
	public irStatistics?: IrAndOutcomeStatisticsModel;
	public uniqueId?: string;
}

export class ScaleMeasureDefinitionModel {
	public scaleMeasureDefinitionId?: number;
	public scaleMeasureItemId: number;
	public description: string;
	public projectIntermediateResultId?: number;
	public scaleMeasureItem?: ScaleMeasureItemModel;
}

export class ScaleMeasureItemModel {
	public scaleMeasureItemId: number;
	public value: number;
	public label: string;
	public scaleMeasureId: number;
	public scaleMeasure?: ScaleMeasureModel;
}

export class ScaleMeasureModel {
	public scaleMeasureId: number;
	public scaleDescription: string;
	public scaleMeasureItems: ScaleMeasureItemModel[];
}

export class IrAndOutcomeStatisticsModel {
	public hasTargets: boolean;
	public targetCount: number;
	public lastTargetValue: number;
	public hasProgress: boolean;
	public totalProgress: number;
	public progressCount: number;
	public totalProgressPercent: number;
	public currentPeriodProgress: number;
	public hasChildren: boolean;
}

export class CustomOutcomeModel {
	public customOutcomeId?: number;
	public projectOutcomeId: number;
	public indicatorName: string;
	public unit: string;
	public parentCustomOutcomes?: CustomOutcomeParentCustomOutcomeModel[];
	public isCalculatedAsRate?: boolean;
	public uniqueId?: string;
}

export class CustomOutcomeParentCustomOutcomeModel {
	public id?: number;
	public customOutcomeId: number;
	public parentCustomOutcomeId: number;
	public outcomeStatement?: string;
	public linkageNotes?: string;
	public parentCustomOutcomeProjectId?: number;
	public parentCustomOutcomeProjectName?: string;
}

export class OutcomeMetricModel {
	public outcomeMetricId: number;
	public name: string;
	public isActive: boolean;
	public preferredUnitId: number;
	public goal2030Id: number;
	public goal2030: Goal2030Model;
	public compatibleUnits: OutcomeUnitModel[];
	public preferredUnit: OutcomeUnitModel;
}

export class OutcomeModel {
	public outcomeId?: number;
	public projectOutcomeId: number;
	public outcomeMetricId: number;
	public outcomeMetric?: OutcomeMetricModel;
	public outcomeUnitId: number;
	public outcomeUnit?: OutcomeUnitModel;
	public parentOutcomes?: OutcomeParentOutcomeModel[];
	public ncsInterventionId?: number;
	public ncsIntervention?: NcsInterventionModel;
	public ncsCountryId?: number;
	public ncsCountry?: GeographyModel;
	public uniqueId?: string;
}

export class OutcomeParentOutcomeModel {
	public id?: number;
	public outcomeId: number;
	public parentOutcomeId: number;
	public outcomeStatement?: string;
	public linkageNotes?: string;
	public parentOutcomeProjectId?: number;
	public parentOutcomeProjectName?: string;
	public parentOutcome?: OutcomeModel;
}

export class OutcomeProgressModel {
	public outcomeProgressId?: number;
	public projectOutcomeId: number;
	public isStart?: boolean;
	public progressDate: Date;
	public progressValue: number;
	public attributionDescription: string;
	public attributionLevelId: number;
	public attributionLevel?: AttributionLevelModel;
	public uniqueId?: string;
	public peopleGender?: OutcomeProgressPeopleGenderModel;
}

export class ChildOutcomeProgressModel extends OutcomeProgressModel {
	public childProjectId?: number;
	public childProjectName?: string;
	public outcomeUnit?: OutcomeUnitModel;
}

export class OutcomeProgressPeopleGenderModel {
	public outcomeProgressPeopleGenderId?: number;
	public outcomeProgressId?: number;
	public women?: number;
	public men?: number;
	public nonBinary?: number;
	public preferNotToSay?: number;
}

export class OutcomeTargetModel {
	public outcomeTargetId?: number;
	public projectOutcomeId: number;
	public targetDate: Date;
	public targetValue: number;
	public uniqueId?: string;
}

export class ChildOutcomeTargetModel extends OutcomeTargetModel {
	public childProjectId?: number;
	public childProjectName?: string;
}

export class OutcomeUnitModel {
	public outcomeUnitId: number;
	public name: string;
	public shortName: string;
	public isActive: boolean;
	public unitConversions: UnitConversionModel[];
}

export class ProjectLinkableOutcomeRequestModel {
	public projectId: number;
	public searchTerm?: string;
}

export class ProjectLinkableOutcomeModel {
	public projectId: number;
	public project?: ProjectModel;
	public projectOutcomeId: number;
	public projectOutcome?: ProjectOutcomeModel;
}

export class ProjectLinkedOutcomeModel extends ProjectLinkableOutcomeModel {
	public id?: number;
}

export class ProjectOutcomeModel {
	public projectOutcomeId?: number;
	public projectId: number;
	public statement: string;
	public sortOrder?: number;
	public isPolicyLeverageOutcome: boolean;
	public outcome?: OutcomeModel;
	public customOutcome?: CustomOutcomeModel;
	public progress?: OutcomeProgressModel[];
	public targets?: OutcomeTargetModel[];
	public outcomeStatistics?: IrAndOutcomeStatisticsModel;
}

export class OutputLinkModel {
	public outputLinkId?: number;
	public projectOutputId: number;
	public name: string;
	public url: string;
}

export class OutputProgressModel {
	public outputProgressId?: number;
	public projectOutputId: number;
	public progressDate?: Date;
	public progressId: number;
	public statusId?: number;
	public description?: string;
	public progress?: OutputProgressValueModel;
	public status?: OutputUpdateStatusModel;
}

export class OutputProgressValueModel {
	public outputProgressValueId: number;
	public label: string;
	public value: number;
	public order: number;
}

export class OutputUpdateStatusModel {
	public outputUpdateStatusId: number;
	public name: string;
	public isActive: boolean;
}

export class ProjectOutputModel {
	public projectOutputId?: number;
	public projectId: number;
	public statement: string;
	public leadId?: number;
	public lead?: UserModel;
	public due?: Date;
	public isArchived?: boolean;
	public outputLinks?: OutputLinkModel[];
	public outputProgress?: OutputProgressModel[];
	public outputStatistics?: OutputStatisticsModel;
	public uniqueId?: string;
}

export class PartnerCategoryModel {
	public partnerCategoryId: number;
	public name: string;
	public isActive: boolean;
}

export class PartnerModel {
	public partnerId: number;
	public partnerCategoryId: number;
	public name: string;
}

export class PartnerRoleModel {
	public partnerRoleId: number;
	public name: string;
	public isActive: boolean;
}

export class ProjectPartnerModel {
	public projectPartnerId?: number;
	public projectId: number;
	public partnerId?: number;
	public partnerRoleId?: number;
	public name: string;
	public contactInfo?: string;
	public email?: string;
	public partnerCategoryId: number;
	public partner?: PartnerModel;
	public partnerCategory?: PartnerCategoryModel;
	public partnerRole?: PartnerRoleModel;
}

export class FavoriteProjectModel {
	public favoriteProjectId?: number;
	public userId: number;
	public projectId: number;
	public project?: ProjectModel;
}

export class ProjectGoalTargetModel {
	public id?: number;
	public uniqueId?: string;
	public projectId: number;
	public goalId: number;
	public targetDate: Date;
	public targetValue: number;
	public targetStatement?: string;
}

export class ProjectInfoModel {
	public projectId?: number;
	public name: string;
	public projectTypeName?: string;
	public statusName?: string;
}

export class ProjectModel extends ProjectInfoModel {
	public projectTypeId: number;
	public briefDescription?: string;
	public localName?: string;
	public statusId?: number;
	public goal?: string;
	public startDate?: Date;
	public completionDate?: Date;
	public completionDateActual?: Date;
	public address?: string;
	public latitude?: number;
	public longitude?: number;
	public relationsNotes?: string;
	public financialNotes?: string;
	public createdBy?: number;
	public createdOn?: Date;
	public modifiedBy?: number;
	public modifiedOn?: Date;
	public isDeleted?: boolean;
	public convertedToProject?: number;
	public isLobbyingRecord?: boolean;
	public projectType?: ProjectTypeModel;
	public status?: StatusModel;
	public intermediateResults?: ProjectIntermediateResultModel[];
	public projectOutcomes?: ProjectOutcomeModel[];
	public linkedOutcomes?: ProjectLinkedOutcomeModel[];
	public projectGoalTargets?: ProjectGoalTargetModel[];
	public projectOutcomeMetricTargets?: ProjectOutcomeMetricTargetModel[];
	public team?: TeamMemberModel[];
	public projectPartners?: ProjectPartnerModel[];
	public outputs?: ProjectOutputModel[];
	public auditLog?: AuditLogModel[];
	public projectBusinessUnits?: ProjectBusinessUnitModel[];
	public projectDonorKeywords?: ProjectDonorKeywordModel[];
	public projectFinancials?: ProjectFinancialModel[];
	public projectFinanceProjects?: ProjectFinanceProjectModel[];
	public states?: ProjectGeographyModel[];
	public countries?: ProjectGeographyModel[];
	public projectSpatialExtents?: ProjectSpatialExtentModel[];
	public projectLinks?: ProjectLinkModel[];
	public projectStrategicPillars?: ProjectStrategicPillarModel[];
	public relations?: ProjectRelationModel[];
	public backwardRelations?: ProjectRelationModel[];
	public budgetsAndActuals?: BudgetActualModel[];
}

export class ProjectOutcomeMetricTargetModel {
	public id?: number;
	public uniqueId?: string;
	public projectId: number;
	public outcomeMetricId: number;
	public targetDate: Date;
	public targetValue: number;
	public targetStatement?: string;
}

export class ProjectRelationModel {
	public projectProjectId?: number;
	public projectId: number;
	public project?: ProjectInfoModel;
	public relatedProjectId: number;
	public relatedProject?: ProjectInfoModel;
	public isPrimary: boolean;
}

export class ProjectTypeModel {
	public projectTypeId: number;
	public name: string;
	public displayOrder: number;
	public isActive: boolean;
}

export class StatusModel {
	public statusId: number;
	public name?: string;
	public displayOrder?: number;
	public isActive: boolean;
}

export class AncillaryTypeModel {
	public ancillaryTypeId: number;
	public name: string;
	public isActive: boolean;
}

export class ProjectLinkModel {
	public projectLinkId?: number;
	public projectId: number;
	public title: string;
	public url: string;
	public viewCount?: number;
	public ancillaryTypeId: number;
	public ancillaryType?: AncillaryTypeModel;
}

export class RecordCollectionModel {
	public recordCollectionId?: number;
	public name?: string;
	public description?: string;
	public isPrivate?: boolean;
	public recordCollectionTypeId?: number;
	public recordCollectionType?: RecordCollectionTypeModel;
	public createdBy?: number;
	public createdOn?: Date;
	public modifiedBy?: number;
	public modifiedOn?: Date;
	public recordCollectionProjects?: RecordCollectionProjectModel[];
	public recordCollectionUsers?: RecordCollectionUserModel[];
	public numberOfProjects?: number;
}

export class RecordCollectionProjectModel {
	public recordCollectionProjectId: number;
	public relatedProjectId: number;
	public relatedProject: ProjectModel;
	public recordCollectionId: number;
}

export class RecordCollectionTypeModel {
	public recordCollectionTypeId: number;
	public name: string;
}

export class RecordCollectionUserModel {
	public collectionUserId: number;
	public recordCollectionId: number;
	public userId: number;
	public user?: UserModel;
}

export class GeographyModel {
	public geographyId: number;
	public geographyTypeId: number;
	public geographyType?: GeographyTypeModel;
	public name: string;
	public parentGeographyId?: number;
	public parentGeography?: GeographyModel;
	public isActive: boolean;
	public iso3Code?: string;
}

export class GeographyTypeModel {
	public geographyTypeId: number;
	public name: string;
	public isActive: boolean;
}

export class ProjectGeographyModel {
	public projectGeographyId?: number;
	public projectId: number;
	public geographyId: number;
	public geography?: GeographyModel;
}

export class ProjectSpatialExtentModel {
	public projectSpatialExtentId?: number;
	public projectId: number;
	public spatialExtentId: number;
	public spatialExtent?: SpatialExtentModel;
}

export class SpatialExtentGroupModel {
	public spatialExtentGroupId: number;
	public name: string;
}

export class SpatialExtentModel {
	public spatialExtentId: number;
	public name: string;
	public isActive: boolean;
	public spatialExtentGroupId: number;
	public spatialExtentGroup: SpatialExtentGroupModel;
}

export class ProjectStrategicPillarModel {
	public projectStrategicPillarId?: number;
	public projectId: number;
	public name: string;
	public description: string;
	public strategicPillarRelatedProjects?: StrategicPillarRelatedProjectModel[];
}

export class StrategicPillarRelatedProjectModel {
	public strategicPillarRelatedProjectId?: number;
	public projectStrategicPillarId?: number;
	public relatedProjectId: number;
	public relatedProject?: ProjectInfoModel;
}

export class UserPortfolioFilterModel {
	public userPortfolioFilterId?: number;
	public userId: number;
	public name: string;
	public uri: string;
}

export class BusinessRoleModel {
	public businessRoleId: number;
	public name: string;
	public displayOrder: number;
	public isActive: boolean;
	public isSingleUserPerProject: boolean;
}

export class TeamMemberModel {
	public projectTeamId?: number;
	public projectId: number;
	public userId: number;
	public user?: UserModel;
	public userBusinessRoles: UserBusinessRoleModel[];
}

export class UserBusinessRoleModel {
	public userBusinessRoleId?: number;
	public businessRoleId: number;
	public projectTeamId?: number;
	public businessRole?: BusinessRoleModel;
}

export class UserInfoModel {
	public userId: number;
	public fullName?: string;
}

export class UserModel extends UserInfoModel {
	public email: string;
	public firstName?: string;
	public lastName?: string;
	public jobTitle?: string;
	public businessUnitId?: number;
	public businessUnit?: BusinessUnitModel;
	public isActive?: boolean;
	public isBlocked?: boolean;
	public isItAdmin?: boolean;
	public userRecordTypeId?: number;
	public initials?: string;
	public createdBy?: string;
	public createdOn?: Date;
	public modifiedBy?: string;
	public modifiedOn?: Date;
	public firstNameOnlyDisplay?: string;
	public employeeId?: string;
	public userApplicationRoles?: UserApplicationRoleModel[];
}

export class AadUserModel {
	public userId: number;
	public isActive: boolean;
	public fullName: string;
	public initials: string;
	public businessUnitName: string;
	public firstName: string;
	public lastName: string;
	public displayName: string;
	public email: string;
	public businessUnitId: number;
}

export class ApplicationRoleModel {
	public applicationRoleId: number;
	public name: string;
}

export class NonTncUserModel {
	public email: string;
	public supervisorUserId: number;
}

export class UserApplicationRoleModel {
	public userApplicationRoleId?: number;
	public userId: number;
	public applicationRoleId: number;
	public applicationRole?: ApplicationRoleModel;
	public businessUnitId?: number;
	public businessUnit?: BusinessUnitModel;
}

export class UserNotificationPreferenceModel {
	public userNotificationPreferenceId: number;
	public userId: number;
	public newRecordLedByMyRegion: boolean;
	public newRecordLedByMyDivision: boolean;
	public newRecordLedByMyBusinessUnit: boolean;
	public recordStatusChangeInMyBusinessUnit: boolean;
	public projectOutcomeProgressValueAddedInMyBusinessUnit: boolean;
	public intermediateResultProgressValueAddedInMyBusinessUnit: boolean;
	public recordStatusChangedInMyStrategy: boolean;
	public projectCreateRelationshipInMyStrategy: boolean;
	public projectRemovesRelationshipInMyStrategy: boolean;
	public projectRelatedToMyStrategyChangeStatus: boolean;
	public recordStatusChangedInMyProject: boolean;
	public strategyCreatesRelationshipInMyProject: boolean;
	public strategyRemovesRelationshipInMyProject: boolean;
	public strategyRelatedToMyProjectChangedStatus: boolean;
	public emailFrequencyId: number;
}

export class UserRecordTypeModel {
	public userRecordTypeId: number;
	public name: string;
}

export class UserSearchModel {
	public searchText?: string;
	public page?: number;
	public applicationRoleFilters?: ApplicationRoleFilterModel[];
	public businessUnitFilters?: BusinessUnitFilterModel[];
	public divisionFilters?: DivisionFilterModel[];
	public regionFilters?: RegionFilterModel[];
	public editorBuFilters?: EditorBuFilterModel[];
	public facet?: string;
}

export class FilterModel {
	public numberOfResults: number;
	public isSelected: boolean;
}

export class ApplicationRoleFilterModel extends FilterModel {
	public applicationRoleId: number;
	public applicationRoleName: string;
}

export class BusinessUnitFilterModel extends FilterModel {
	public businessUnitId: number;
	public businessUnitName: string;
}

export class DivisionFilterModel extends FilterModel {
	public divisionId: number;
	public divisionName: string;
}

export class RegionFilterModel extends FilterModel {
	public regionId: number;
	public regionName: string;
}

export class EditorBuFilterModel extends FilterModel {
	public editorBusinessUnitId: number;
	public editorBusinessUnitName: string;
}

export class UsersSearchResultModel {
	public users: UserModel[];
	public filteredUsersCount: number;
	public filteredPagesCount: number;
	public page: number;
	public applicationRoleFilters: ApplicationRoleFilterModel[];
	public businessUnitFilters: BusinessUnitFilterModel[];
	public divisionFilters: DivisionFilterModel[];
	public regionFilters: RegionFilterModel[];
	public editorBuFilters: EditorBuFilterModel[];
}

export class RecordCollectionsSearchModel {
	public searchText?: string;
	public isPrivate?: boolean;
	public page?: number;
	public collectionTypeFilters?: CollectionTypeFilterModel[];
}

export class CollectionTypeFilterModel {
	public recordCollectionTypeId: number;
	public collectionTypeName?: string;
	public numberOfResults?: number;
	public collectionType?: RecordCollectionTypeModel;
	public isSelected?: boolean;
}

export class RecordCollectionsSearchResultModel {
	public recordCollections: RecordCollectionModel[];
	public totalCollectionsCount: number;
	public filteredCollectionsCount: number;
	public totalPagesCount: number;
	public filteredPagesCount: number;
	public page: number;
	public availableFilters: CollectionTypeFilterModel[];
}

export class OutputDetailsModel {
	public projectOutputId: number;
	public links: OutputLinkModel[];
	public progress: OutputProgressModel[];
}

export class OutputStatisticsModel {
	public hasProgress: boolean;
	public latestProgressDate?: Date;
	public latestProgressPercent?: number;
	public latestProgressStatus?: string;
}

export class AvailableParentProjectOutcomeModel {
	public strategyId: number;
	public strategyName: string;
	public projectOutcome: ProjectOutcomeModel;
	public isPrimaryStrategy: boolean;
}

export class AvailableParentProjectOutcomeRequestModelBase {
	public projectId: number;
	public searchTerm: string;
}

export class AvailableParentOutcomeRequestModel extends AvailableParentProjectOutcomeRequestModelBase {
	public outcomeMetricId: number;
}

export class AvailableParentCustomOutcomeRequestModel extends AvailableParentProjectOutcomeRequestModelBase {
	public indicatorName: string;
}

export class OutcomeDetailsModel {
	public projectOutcomeId: number;
	public targets: OutcomeTargetModel[];
	public progress: OutcomeProgressModel[];
	public childTargets?: ChildOutcomeTargetModel[];
	public childProgress?: ChildOutcomeProgressModel[];
	public unitConversions?: UnitConversionModel[];
}

export class RelationOutcomeListModel {
	public strategyName: string;
	public relationType: string;
	public isReciprocal: boolean;
	public outcomes: ProjectOutcomeModel[];
}

export class UnitConversionModel {
	public unitConversionId: number;
	public sourceUnitId: number;
	public targetUnitId: number;
	public conversion: number;
}

export class NcsBaselineModel {
	public baselineId: number;
	public name: string;
}

export class NcsGeographyInterventionModel {
	public geographyInterventionId?: number;
	public geographyId: number;
	public interventionId: number;
	public geography?: GeographyModel;
	public baselineValue?: number;
	public createdBy?: number;
	public createdOn?: Date;
	public modifiedBy?: number;
	public modifiedOn?: Date;
	public modifiedByNavigation?: UserModel;
	public geographyInterventionPools?: NcsGeographyInterventionPoolModel[];
}

export class NcsGeographyInterventionPoolModel {
	public geographyInterventionPoolId?: number;
	public geographyInterventionId: number;
	public poolId: number;
	public pool?: NcsPoolModel;
	public defaultValue?: number;
}

export class NcsInterventionModel {
	public interventionId: number;
	public pathwayId: number;
	public pathwayName: string;
	public name: string;
	public calculation: string;
	public baselineId: number;
	public baseline: NcsBaselineModel;
	public geographyInterventions?: NcsGeographyInterventionModel[];
	public pools?: NcsPoolModel[];
}

export class NcsPathwayModel {
	public pathwayId: number;
	public name: string;
	public interventions: NcsInterventionModel[];
}

export class NcsPoolModel {
	public poolId: number;
	public name: string;
	public description: string;
	public unit: string;
}

export class NotificationModel {
	public notificationId: number;
	public userId: number;
	public user?: UserModel;
	public initiatorUserId: number;
	public initiatorUser?: UserModel;
	public bodyHtml: string;
	public dateTime: Date;
	public hasBeenViewed: boolean;
	public bodyText: string;
}

export class IntermediateResultChartDataModel {
	public date: Date;
	public intermediateResultId: number;
	public targetValue?: number;
	public relatedTargetsValue?: number;
	public currentPeriodProgress: number;
	public priorCumulativeProgress: number;
}

export class IntermediateResultDetailsModel {
	public intermediateResultId: number;
	public projectId: number;
	public targets: IntermediateResultTargetModel[];
	public progress: IntermediateResultProgressModel[];
	public childTargets?: ChildIntermediateResultTargetModel[];
	public childProgress?: ChildIntermediateResultProgressModel[];
}

export class BudgetActualModel {
	public fiscalYear: number;
	public totalBudgetUsdAmount: number;
	public totalActualUsdAmount: number;
}

export class FinanceProjectModel {
	public id: number;
	public name: string;
	public status: string;
	public startDate?: Date;
	public endDate?: Date;
	public financeProjectTypeId: number;
	public financeStateId: number;
	public businessUnitId?: number;
	public businessUnitName?: string;
	public workdayCode: string;
}

export class LinkedFinanceProjectModel extends FinanceProjectModel {
	public linkedProjectId?: number;
}

export class ProjectFinanceProjectModel {
	public id?: number;
	public projectId: number;
	public financeProjectId: number;
	public financeProject?: FinanceProjectModel;
	public isActive?: boolean;
	public isArchived?: boolean;
	public createdById?: number;
	public createdByUser?: UserModel;
	public createdOn?: Date;
	public modifiedById?: number;
	public modifiedByUser?: UserModel;
	public modifiedOn?: Date;
}

export class AuditBulkLogModel {
	public auditBulkLogId: number;
	public action: string;
	public actionDate: Date;
	public userId: number;
	public user: UserModel;
}

export class BulkEditUpdateUserModel {
	public bulkEditUpdateUserId?: number;
	public initiatedOn?: Date;
	public initiatedById?: number;
	public rolesId: string;
	public businessUnitsId?: string;
	public newUserId: number;
	public currentUserId?: number;
	public currentUser?: UserModel;
	public initiatedBy?: UserModel;
	public newUser?: UserModel;
}

export class ApiTokenModel {
	public apiKey: string;
	public apiSecret: string;
	public userEmail: string;
}

export class HubUserModel {
	public userId: number;
	public email: string;
	public firstName: string;
	public lastName: string;
	public initials: string;
	public preferredFullName: string;
	public jobTitle: string;
	public businessUnitId?: number;
	public regionId?: number;
	public divisionId?: number;
	public isActive: boolean;
	public isBlocked: boolean;
	public isItAdmin: boolean;
	public objectId: string;
	public applicationRoles: ApplicationRoleModel[];
	public editableBusinessUnits: BusinessUnitModel[];
}

export class TokenRequestModel {
	public idToken: string;
}

export class ApiTokenRequestModel {
	public apiKey: string;
	public apiSecret: string;
}

export class TokenResponseModel {
	public accessToken: string;
	public tokenType: string;
	public expiresIn: number;
	public refreshToken: string;
	public userId: number;
	public userFirstName: string;
	public userLastName: string;
	public userInitials: string;
	public preferredFullName: string;
	public initials: string;
	public businessUnitId?: number;
	public regionId?: number;
	public divisionId?: number;
}

export class EmailFrequencyModel {
	public emailFrequencyId: number;
	public name: string;
	public description: string;
}

